<template>
    <div :class="mode==='dark'?'dark':'light'">
        <!-- TODO: Informacion de actualizar perfil-->
        <b-button v-b-modal.modal-1 hidden>Launch demo modal</b-button>
		<b-modal id="modal-1" title="Actualiza tus datos">
			<p class="my-4">
				Para continuar participando y recibir información de temas de tu
				interés, te invitamos a actualizar tus datos en la plataforma Congreso Virtual.
			</p>
			<template #modal-footer>
				<a class="mt-3 btn btn-success btn-block" href="/user?update=1">Actualizar perfil</a>
			</template>
		</b-modal>
        <div class="container">
            <div class="row no-gutters">
                <div v-if="loadPublicConsultation" class="vld-parent">
                    <img src="../assets/img/loader2.gif" style="height:600px;width:1200px" class="pl-0 ma-10 img-fluid col-12">
                </div>
                <PublicConsultationHeader v-if="!loadPublicConsultation" :publicConsultation="publicConsultation"></PublicConsultationHeader>
                <nav aria-label="breadcrumb" class="container px-0">
                    <ol class="breadcrumb" :style="mode==='dark'?'background: rgb(12, 1, 80);':''">
                        <li class="breadcrumb-item"><a href="/" :style="mode==='dark'?'color: #fff':''">{{ $t('consulta.breadcumb.inicio') }}</a></li>
                        <li class="breadcrumb-item active" aria-current="page"><a href="/public_consultations" :style="mode==='dark'?'color: #fff':''">{{ $t('consulta.breadcumb.proyectos') }}</a></li>
                        <li class="breadcrumb-item active" aria-current="page" :style="mode==='dark'?'color: #fff':''">{{ $t('consulta.breadcumb.consulta') }} {{ publicConsultation.id }}</li>
                    </ol>
                </nav>
                <div class="hk-sec-wrapper hk-gallery-wrap"
					:style="mode === 'dark' ? 'background: rgb(12, 1, 80);color: #fff' : ''">
					<div class="row px-10">
						<div class="col-sm-12 slider-wrapper">
							<ul class="nav nav-light nav-pills nav-fill" role="tablist"
								:data-intro="$t('proyecto.ruta_guiada.pasos.paso_1')" data-step="1">
								<li id="list-sections" class="nav-item" v-bind:class="1 ? 'active' : ''" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_3')"
									data-step="3">
									<a id="general-info-ideas-articles-tab" data-toggle="tab" href="#general-info-ideas-articles"
										role="tab" aria-controls="general-info-ideas-articles" aria-selected="true" class="nav-link"  v-bind:class="1 ? 'active' : ''"
										:style="mode === 'dark' ? 'color: #fff' : ''">
										<!-- Resumen -->
										{{ $t('proyecto.tabs.resume') }}
									</a>
								</li>
                                <li v-if="1" id="section-info" class="nav-item" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_5')"
									data-step="5">
									<a id="detail-video-tab" data-toggle="tab" href="#detail-video" role="tab"
										aria-controls="detail-video" aria-selected="true" class="nav-link" @click="loadProjectI = true"
										:style="mode === 'dark' ? 'color: #fff' : ''">
										<!-- Vota y Opina -->
										{{ $t('proyecto.tabs.voteandopine') }}
									</a>
								</li>
                                <li id="section-documentos" class="nav-item" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_8')"
									data-step="8">
									<a id="anexos-tab" data-toggle="tab" href="#anexos" role="tab"
										aria-controls="anexos" aria-selected="true" class="nav-link"
										:style="mode === 'dark' ? 'color: #fff' : ''">
										{{ $t('proyecto.tabs.annexes') }}
									</a>
								</li>
								
							</ul>
                            <div class="tab-content py-25">
								<div id="general-info-ideas-articles" class="tab-pane fade show" role="tabpanel"
									aria-labelledby="general-info-ideas-articles-tab" v-bind:class="1 ? 'active' : ''">
									<div class="row">
										<!--h3 class="text-center p-3" :style="mode==='dark'?'color: #fff':''">{{ $t('proyecto.contenido.tab.detalle') }}</h3-->
										<div class="col-12 mb-5 mx-5" v-html="publicConsultation.resumen"></div>
										<div v-if="ver_mas" class="col-12 mx-5" v-html="publicConsultation.detalle">
										</div>
										<p @click="ver_mas = !ver_mas" href class="seemore-trigger">{{ ver_mas ? "Leer menos" : "...Leer mas" }}</p>
										<div v-if="publicConsultation.video" class="col-12 px-5 mt-30 text-center">
											<h5>{{ $t('proyecto.contenido.video') }}</h5>
											<div class="col-12 d-flex justify-content-center">
												<div class="col-6 embed-responsive embed-responsive-16by9 mt-20" v-html-safe="publicConsultation.video">
												</div>
											</div>
										</div>
									</div>
								</div>
                                <div id="detail-video" class="tab-pane fade show" role="tabpanel" aria-labelledby="detail-video-tab">
									<div class="collapse show w-100" id="collapseIdeas">
                                            <ProjectIdeas v-if="!loadPublicConsultation && loadProjectI" :id="publicConsultation.id" :project="publicConsultation"
											@updateStackedChartVotos="forceRerender"></ProjectIdeas>
									</div>
								</div>
								<div id="anexos" class="tab-pane fade show" aria-labelledby="anexos-tab">
									<PublicConsultationFiles :public_consultation_id="this.public_consultation_id"></PublicConsultationFiles>
								</div>
							</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PublicConsultationHeader from '../components/public_consultations/PublicConsultationHeader';
    import ProjectIdeas from '../components/public_consultations/PublicConsultationIdeas';
	import PublicConsultationFiles from '../components/public_consultations/PublicConsultationFiles';
    import axios from '../backend/axios';
    import { bus } from '../main';

    export default {
        name: 'PublicConsultation',
        components: {
            PublicConsultationHeader,
            ProjectIdeas,
			PublicConsultationFiles
        },
        props: {
            public_consultation_id: Number
        },
        data() {
            return {
                publicConsultation: Object,
                loadPublicConsultation: true,
                keyStackedChartComponent: 0,
                ver_mas: false,
                mode: String,
			    loadProjectI: false,
            };
        },
        mounted() {
            if((this.$store.getters.modo_oscuro === 'dark') || (window.location.href.includes('dark'))) {
                this.mode = 'dark';
            } else {
                this.mode = 'light';
            }

            this.getPublicConsultation();
            let lablesButtons = {
			nextLabel: this.$t('proyecto.ruta_guiada.opciones.boton_siguiente'),
			prevLabel: this.$t('proyecto.ruta_guiada.opciones.boton_anterior'),
			skipLabel: this.$t('proyecto.ruta_guiada.opciones.boton_salir'),
			doneLabel: this.$t('proyecto.ruta_guiada.opciones.boton_finalizar')
            };
            bus.$on('tour', function () {
                const introJS = require('intro.js');
                introJS
                    .introJs()
                    .setOption('nextLabel', lablesButtons.nextLabel)
                    .setOption('prevLabel', lablesButtons.prevLabel)
                    .setOption('skipLabel', lablesButtons.skipLabel)
                    .setOption('doneLabel', lablesButtons.doneLabel)
                    .setOption('scrollToElement', true)
                    .start()
                    .onchange(function (targetElement) {
                        if ($(targetElement).attr("data-step") == 4) {
                            $('#btn-ideas').click();
                        }
                    })
            });
            this.getUser();
        },
        methods: {
            focusVotesSection(e) {
                $('#modalMessage').modal('hide');

                $('html, body').animate({
                    scrollTop: $('#section-votes').offset().top + 'px'
                }, 1500);
                $('#btn-ideas').click();
            },
            getPublicConsultation() {
                axios
                    .get('/consultations/' + this.public_consultation_id)
                    .then(res => {
                        this.publicConsultation = res.data;
                        this.publicConsultation.alternativas = JSON.parse(this.publicConsultation.alternativas);
                    })
                    .finally(() => {
                        this.loadPublicConsultation = false;
                    });
            },
            forceRerender() {
			this.keyStackedChartComponent += 1;
		    },
            getUser() {
			if (this.$store.getters.isLoggedIn) {
				axios
					.get('/auth/user')
					.then(res => {
						if (!res.data.actividad ) {
							this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
						}
                        if (!res.data.birthday) {
							this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
						}
                        if (!res.data.pais) {
							this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
						}
                        if (!res.data.name) {
							this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
						}
                        if (!res.data.surname) {
							this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
						}
                        if (!res.data.sector) {
							this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
						}
                        if (!res.data.genero) {
							this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
						}
                        if (!res.data.region) {
							this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
						}
					})
					.finally(() => {
					});
			}
		},
        },
        computed: {
            isAvailableGamification() {
                return this.$store.getters.activeGamification;
            }
        }
    }
</script>
<style scoped>

.slider-wrapper{
	flex: auto;
}
.arrow-steps .step {
	font-size: 14px;
	cursor: default;
	padding: 10px 10px 10px 30px;
	float: left;
	position: relative;
	background-color: #d9e3f7;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	transition: background-color 0.2s ease;
}

.arrow-steps .step:after,
.arrow-steps .step:before {
	content: " ";
	position: absolute;
	top: 0;
	right: -16px;
	width: 0;
	height: 0;
	border-top: 25px solid transparent;
	border-bottom: 25px solid transparent;
	border-left: 17px solid #9e9e9e !important;
	z-index: 2;
	transition: border-color 0.2s ease;
}

.arrow-steps .bg-primary.step:before {
	border-left: 17px solid green !important;
}

.arrow-steps .step:before {
	right: auto;
	left: 0;
	border-left: 17px solid #fff;
	z-index: 0;
}

.arrow-steps .step:first-child:before {
	border: none;
}

.arrow-steps .step:first-child {
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.arrow-steps .step span {
	position: relative;
}

.arrow-steps .step span:before {
	opacity: 0;
	content: "✔";
	position: absolute;
	top: -2px;
	left: -20px;
}

.arrow-steps .step.done span:before {
	opacity: 1;
	-webkit-transition: opacity 0.3s ease 0.5s;
	-moz-transition: opacity 0.3s ease 0.5s;
	-ms-transition: opacity 0.3s ease 0.5s;
	transition: opacity 0.3s ease 0.5s;
}

.arrow-steps .step.current {
	color: #fff;
	background-color: green !important;
}

.arrow-steps .step.current:after {
	border-left: 17px solid green !important;
}

/* .idea_style {
    padding-left: 5px !important;
    padding-right: 53px!important;
} */

.hk-sec-wrapper {
    width: 100%;
    background: #fff;
    padding: 4.5rem !important;
    padding-top: -39.5rem;
    padding-right: -27.5rem;
    padding-bottom: -21.5rem;
    padding-left: -122.5rem;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: -7.75rem;
    margin-bottom: 13px;
}

@media (max-width: 767px) {
    .hk-sec-wrapper {
        padding: 1.5rem !important;
    }
}


</style>
